import "./Modal.css"
import { createPortal } from "react-dom";
function Modal({ modalStatus, changeStatus, t, w, h, title, content, footer , menu}) {


    let wBox = (100 - w) / 2
    let hBox = "75vh";
    let tBox = 10;
    let mHeight = 98
    if (h) {
        hBox = h + "vh"
    }
    if (t) {
        tBox = t
        

    }
    mHeight = mHeight - parseInt(tBox)
    const styleBox = {
        top: `${tBox}vh`,
        width: `${w}%`,
        height: `${hBox}`,
        left: `${wBox}%`,
        minWidth: "300px",
        maxHeight: `${mHeight}vh`,




    }




    if (!modalStatus) return null

    // Renderizado via portal direto no <body>: um modal aberto a partir de dentro de
    // outro form (ex: cadastro rápido de fornecedor dentro do form de cor/produto)
    // não pode ficar como <form> aninhado no DOM, senão o submit de dentro aciona
    // também o submit de fora e fecha o modal errado.
    return createPortal(
        <div className={"model-bg-m-1"}  >
            <div style={styleBox} className={`model-box-m-1`} id="modal-box"  >

                <div className="box-x"> <button type="button" onClick={() => { changeStatus(false) }} className="shd-modal-close">X</button></div>
                {(title || menu) && (
                    <div>
                        {title && <p className='shd-title-m-1'>{title}</p>}
                        <div>{menu}</div>
                    </div>
                )}

                <div className='model-box-content'>


                    {content}
                </div>
            </div>
        </div>,
        document.body
    )
}

export default Modal